<template>
	<div class="quantity-buttons-wrapper no-highlight" :class="customType" role="group" :aria-labelledby="ariaId">
		<div class="button--quantity"
			tabindex="0"
			:aria-label="`decrease ${itemName} quantity`"
			:id="`${ariaId}-dec`"
			role="button"
			@keydown.enter="decrement"
			@click="decrement">
			<BaseIcon :class="{icon: true}" icon="minusIcon" size="lg"/>
		</div>
		<input pattern="\d{1,3}"
			:id="ariaId"
			class="quantity text-input"
			:value="quantity"
			:aria-label="`${itemName} quantity`"
			aria-live="polite"
			aria-relevant="text"
			:aria-controls="`${ariaId}-dec ${ariaId}-inc`"
			v-on:input="handleInput"
			ref="quantityField"
			@focus="handleFocus"/>
		<div class="button--quantity"
			tabindex="0"
			:aria-label="`increase ${itemName} quantity`"
			:id="`${ariaId}-inc`"
			role="button"
			@keydown.enter="increment"
			@click="increment">
			<BaseIcon :class="{icon: true}" icon="plusIcon" size="lg"/>
		</div>
	</div>
</template>

<script>

	export default {
		props: {
			settings: {
				type: Object,
			},
			quantity: {
				type: Number,
				default: 1,
			},
			customType: {
				type: String,
				default: '',
			},
		},
		computed: {
			ariaId() {
				if (this.settings) {
					const item = this.settings.item;
					if (!item.id) {
						return `q-id`;
					}
					const itemId = item.id.replace('~','_');
					return `${itemId}-q-id`;
				}
				return `q-id`;
			},
			itemName() {
				if (this.settings) {
					const item = this.settings.item;
					return item.name;
				}
				return '';
			}
		},
		methods: {
			handleInput(event) {
				let value = event.target.value;
				if (isNaN(+value)) {
					value = 1;
				}
				value = Math.min(value, 100);
				value = Math.max(value, 1);
				value = `${value}`;
				const inputField = this.$refs['quantityField'];
				inputField.value = value;

				this.$emit('setInputQuantity', value);
			},
			handleFocus(event) {
				event.target.select();
			},
			increment(event) {
				this.$emit('incrementQuantity', event);
			},
			decrement(event) {
				this.$emit('decrementQuantity', event);
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';

	.quick-add-overlay {
		position: absolute;
		bottom: 0;
		left: 0;
		border-radius: 24px;
		background-color: $storeButtonColor;
		color: $storeButtonTitleColor;
		z-index: $zModalTopLayer;
		.text-input {
			background-color: $storeButtonColor;
			color: $storeButtonTitleColor;
		}
	}

	.quantity-buttons-wrapper {
		display: flex;
		align-items: center;

		margin-top: 1em;
	}
	.quantity {
		margin-left: 0.3rem;
		margin-right: 0.3rem;
		width: 2em;

		color: $storeButtonColor;

		text-align: center;
	}
	input.quantity {
		border: none;

		min-width: 3rem;

		font-size: 1rem;
		text-align: center;
		transition: all .3s;
		&:focus {
			width: 4rem;
		}
	}
	.button--quantity {
		color: $storeButtonColor;

		font-size: 16pt;
		cursor: pointer;
	}
	.button--text {
		display: flex;
		align-items: center;
		justify-content: center;

		width: 0.5rem;
		height: 0.5rem;
	}
	.text-input {
		background-color: $landingPageBackground;
	}
	@include mobile {
		.quantity-buttons-wrapper{
			margin-top: 0;
		}
		.button--quantity {
			font-size: 1rem;
		}
		input.quantity {
			min-width: 1rem;
			text-indent: 0rem;
		}
		.quick-add-overlay {
			top: -4px;
			bottom: unset;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseQuantityButtons.vue